import { OBJECT_TYPE } from 'framework-asset-preview-lib/internal/shared/constants/objectTypes';
import { getContentPerformanceStats } from 'framework-asset-preview-lib/internal/objectTypes/0-10/utils';
import { getFormPerformanceStats } from 'framework-asset-preview-lib/internal/objectTypes/0-28/utils';
import { getEmailPerformanceStats } from 'framework-asset-preview-lib/internal/objectTypes/0-29/utils';
import { getSmsPerformanceStats } from 'framework-asset-preview-lib/internal/objectTypes/0-124/utils';
import { getWorkflowPerformanceStats } from 'framework-asset-preview-lib/internal/objectTypes/0-44/utils';
import { getSocialBroadcastPerformanceStats } from 'framework-asset-preview-lib/internal/objectTypes/0-71/utils';
import { getCtaPerformanceStats } from 'framework-asset-preview-lib/internal/objectTypes/0-42/utils';
import { getWebInteractivePerformanceStats } from 'framework-asset-preview-lib/internal/objectTypes/0-91/utils';
/**
 * Aggregator to fetch all stats for a given object type.
 * As we can't control where the information is coming from,
 * we can use separate endpoints for each object type and
 * always return the same payload.
 *
 * This way, the UI doesn't have to know where the information is coming from
 * and will always render the same consistent information.
 */
export function fetchStatisticsForObjectType({
  crmObject,
  nonCrmObject,
  options
}) {
  switch (crmObject.objectTypeId) {
    default:
      return Promise.resolve([]);
    case OBJECT_TYPE.FORM:
      return getFormPerformanceStats({
        crmObject,
        nonCrmObject
      });
    case OBJECT_TYPE.MARKETING_EMAIL:
      return getEmailPerformanceStats({
        crmObject,
        nonCrmObject,
        options
      });
    case OBJECT_TYPE.BLOG_POST:
    case OBJECT_TYPE.CONTENT:
    case OBJECT_TYPE.LANDING_PAGE:
    case OBJECT_TYPE.SITE_PAGE:
      return getContentPerformanceStats(crmObject);
    case OBJECT_TYPE.SOCIAL_BROADCAST:
      return getSocialBroadcastPerformanceStats({
        crmObject,
        nonCrmObject
      });
    case OBJECT_TYPE.WORKFLOW:
      return getWorkflowPerformanceStats({
        crmObject,
        nonCrmObject
      });
    case OBJECT_TYPE.CTA:
      return getCtaPerformanceStats(crmObject);
    case OBJECT_TYPE.MARKETING_SMS:
      return getSmsPerformanceStats(crmObject);
    case OBJECT_TYPE.WEB_INTERACTIVE:
      return getWebInteractivePerformanceStats(crmObject);
  }
}